'use strict';

module.exports = {

    AWS_BASE_URL: process.env.VUE_APP_AWS_BASE_URL || 'https://hbca2f6qck.execute-api.eu-central-1.amazonaws.com/prod',

    APPMIXER_DOCS_URL: process.env.VUE_APP_APPMIXER_DOCS_URL || 'https://docs.appmixer.com'
};
